import React, { CSSProperties, useEffect } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { useModalContext } from '../../../Modal/Services/ModalContext';

interface Props {
	children?: React.ReactNode;
	formMethods: UseFormReturn<any>;
	style?: CSSProperties | undefined;
	registerForChanges?: boolean;
}

const FormWrapper = ({
	children,
	formMethods,
	style,
	registerForChanges = true,
}: Props) => {
	const modalContext = useModalContext();

	useEffect(() => {
		if (registerForChanges) {
			modalContext?.registerForm(() => formMethods);
		}
		return () => {
			if (registerForChanges) {
				modalContext?.unregisterForm(() => formMethods);
			}
		};
	}, []);

	return (
		<FormProvider {...formMethods}>
			<form action='' style={style}>
				{children}
			</form>
		</FormProvider>
	);
};

export default FormWrapper;
